module.exports = __webpack_public_path__ + "static/media/Cyber-navy-blue.d920f10c.svg";